import PaymentOptions from '../pages/PaymentOptions';

const paymentOptionsRoutePage = {
  component: <PaymentOptions />,
  route: '/opcoes-de-pagamento',
};

export { paymentOptionsRoutePage };
